import { Routes, Route } from 'react-router-dom'
import OrderReportTable from '../pedido/relatorio/orderReportTable'

export default () => {
    return <Routes>
            <Route path="/pedido/relatorio" element={<OrderReportTable />}/>
    </Routes>
}